import * as R from 'ramda'

import { categoryNames } from 'components/common/JobProfileWidget/text'

export const COMPETENCIES_FIELD = 'competencies'

export const getFields = () =>
  R.pipe(
    R.keys,
    R.sort(R.comparator(R.lt)),
    R.map(name => ({ [name]: false, name })),
  )(categoryNames())

export const getDefaultValues = () => ({
  [COMPETENCIES_FIELD]: getFields(),
})
